import React from "react"
import PageHeader from "./PageHeader"
import PageHeaderBanner from "./PageHeaderBanner"
import PageHeaderContainer from "./PageHeaderContainer"
import PageHeaderDetails from "./PageHeaderDetails"

const PageHeaderDropdown = ({ 
  styleName, 
  currentCategory, 
  categories = [], 
  categoriesMap = {}, 
  message,
  onCategoryChange 
}) => {
  // Filter to get only top-level categories (level 1)
  const topLevelCategories = categories.filter(cat => cat.level === 1)
  
  const handleCategoryClick = (category) => {
    if (onCategoryChange) {
      onCategoryChange(category)
    } else {
      // Default behavior: navigate to category URL
      window.location.href = category.url.index
    }
  }

  return (
    <PageHeaderContainer>
      <PageHeader styleName={styleName}>
        <PageHeaderBanner styleName={styleName}>
          <div className="dropdown page-header-dropdown">
            <button
              className="btn btn-link dropdown-toggle page-header-dropdown-btn"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <h1 className="page-header-dropdown-title">
                {currentCategory.name}
                <span className="material-icon">arrow_drop_down</span>
              </h1>
            </button>
            <ul className="dropdown-menu page-header-dropdown-menu">
              {topLevelCategories.map((category) => (
                <li key={category.id}>
                  <a
                    href={category.url.index}
                    className="page-header-dropdown-item"
                    onClick={(e) => {
                      e.preventDefault()
                      handleCategoryClick(category)
                    }}
                  >
                    <span
                      className="material-icon page-header-dropdown-icon"
                      style={{ color: category.color || "#6b7280" }}
                    >
                      label
                    </span>
                    <span className="page-header-dropdown-name">
                      {category.name}
                    </span>
                    {category.description && (
                      <span className="page-header-dropdown-desc">
                        {category.description}
                      </span>
                    )}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </PageHeaderBanner>
        {message && (
          <PageHeaderDetails styleName={styleName}>{message}</PageHeaderDetails>
        )}
      </PageHeader>
    </PageHeaderContainer>
  )
}

export default PageHeaderDropdown